export default {
  showMore: 'Ver más',
  hide: 'Ocultar',
  coAuthors: 'Colaboradores',
  website: 'Sitio web:'
}

export const en = {
  showMore: 'Show more',
  hide: 'Hide',
  coAuthors: 'Collaborators',
  website: 'Website:'
}

export const ca = {
  showMore: 'Mostra més',
  hide: 'Amaga',
  coAuthors: 'Col·laboradors',
  website: 'Lloc web:'
}
